<template>
    <div>
        <modal class="verfied-alarm-modal" :display="modalStatus.bizWaitVerified" @modalStatus="closeModal" >
            <div class="verfied-alarm-modal-wrap">
                <img src="@/assets/img/icon/modal_alarm_orange.svg" alt="" srcset="">
                <h1>等待審核中</h1>
                <div class="description">企業認證資料審核中，審核通過即可進行操作。</div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="submit">確認</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    props: {
  
    },
    mounted() {
        // this.$analytics.logEvent('實名認證提醒', { screen_name: '實名認證提醒'})
    },
    methods: {
        submit: function () {
            this.closeModal()
            this.$router.push({ name: 'bizHomeDefault'})
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizWaitVerified'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.verfied-alarm-modal{
        .cancle{
            display: none;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .verfied-alarm-modal-wrap{
                        padding: 40px 32px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    h1{
                        font-size: 24px;
                        margin-top: 24px;
                        margin-bottom: 16px;
                    }
                    .description{
                        line-height: 1.57;
                        color: #676362;
                        margin-bottom: 32px;
                    }
                  
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 200px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/waitVerified.vue